import PropTypes from "prop-types";

export const UNIDADE = {
  codigo: 1,
  descricao: "Unidade",
  simbolo: "un",
};

export const MILHEIRO = {
  codigo: 8,
  descricao: "Milheiro",
  simbolo: "mil",
};

export const QUILO = {
  codigo: 2,
  descricao: "Quilograma",
  simbolo: "kg",
};

export const TONELADA = {
  codigo: 7,
  descricao: "Tonelada",
  simbolo: "T",
};

export const METRO = {
  codigo: 3,
  descricao: "Metro",
  simbolo: "m",
};

export const METRO_QUADRADO = {
  codigo: 4,
  descricao: "Metro Quadrado",
  simbolo: "m²",
};

export const METRO_CUBICO = {
  codigo: 5,
  descricao: "Metro Cúbico",
  simbolo: "m³",
};

export const LITRO = {
  codigo: 6,
  descricao: "Litro",
  simbolo: "l",
};

export const HORA = {
  codigo: 9,
  descricao: "Hora",
  simbolo: "h",
};

export const DIARIA = {
  codigo: 10,
  descricao: "Diária",
  simbolo: "dia",
};

export const MENSALIDADE = {
  codigo: 11,
  descricao: "Mensalidade",
  simbolo: "mês",
};

export const QUILOWATT_HORA = {
  codigo: 12,
  descricao: "Quilowatt-hora",
  simbolo: "kwh",
};

export const values = [
  UNIDADE,
  MILHEIRO,
  QUILO,
  TONELADA,
  METRO,
  METRO_QUADRADO,
  METRO_CUBICO,
  LITRO,
  HORA,
  DIARIA,
  MENSALIDADE,
  QUILOWATT_HORA,
];

export const valueOf = (codigo) => {
  for (let i = 0; i < values.length; i++) {
    const cs = values[i];
    if (cs.codigo === codigo) {
      return cs;
    }
  }

  return UNIDADE;
};

this.propTypes = {
  codigo: PropTypes.number.isRequired,
  descricao: PropTypes.string.isRequired,
  simbolo: PropTypes.string.isRequired,
};

this.defaultProps = {
  codigo: null,
  descricao: null,
  simbolo: null,
};



// WEBPACK FOOTER //
// ./src/constantes/CsTipoUnidade.js